export default {
  formFields: {
    'fieldHelp': 'Kattintson a leírás megnyitásához',
    'defaultAbbreviation': 'alapért.: ',
    'paramJSONContent': 'JSON-tartalom',
    'wrongInputValue': 'Helytelen bemeneti érték ehhez a paraméterhez.',
    'notValidJsonString': 'Nincs érvényes Json ehhez: :fieldName'
  }
}
